import SlotTemplate from "./SlotTemplate";
export default SlotTemplate;
export { default as SlotTemplate } from "./SlotTemplate";
